<template>
    <Layout>
        <div class="container section m_height">
            <div class="registration_steps text-justify">
                <h1 class="cl_gr text-uppercase my-3">Registration</h1>

                <p v-html="conferenceTextData.activation_code_text"></p>
            </div>

            <form class="register_form" @submit="identifyClientSubmitted">
                <div
                    class="alert alert-danger"
                    v-if="errorMsg != ''"
                    v-html="errorMsg"
                >
                </div>

                <div class="form-group form-check">
                    <label class="form-check-label">
                        <input
                            v-model="isAgreed"
                            class="form-check-input"
                            type="checkbox"
                        />I have read and accept the above conditions of
                        participation
                    </label>
                </div>

                <div class="form-group required">
                    <div class="row">
                        <div
                            :class="{
                                'has-error': $v.invitation_code.$error,
                                'col-sm-12': true,
                            }"
                        >
                            <label for="activation_code">Activation code</label>
                            <input
                                v-model="invitation_code"
                                type="text"
                                name="activation_code"
                                class="form-control"
                                id="activation_code"
                            />
                            <small
                                class="text-danger"
                                v-if="!$v.invitation_code.required"
                                >Field is required</small
                            >
                        </div>
                    </div>
                </div>

                <button type="submit" class="btn btn-success mt-3">
                    Activate
                </button>

                <a href="" type="submit" class="btn btn-danger mt-3 ml-3"
                    >Cancel</a
                >
            </form>
        </div>
    </Layout>
</template>

<script>
import Layout from "@/components/layouts/Layout.vue";
import { required } from "vuelidate/lib/validators";
import { mapGetters } from 'vuex';
import Api from "@/Api";

export default {
    name: "Identify",
    components: { Layout },
    computed: {
        ...mapGetters(['conferenceTextData'])
    },
    data() {
        return {
            invitation_code: "",
            isAgreed: false,
            errorMsg: ""
        };
    },
    validations: {
        invitation_code: { required },
    },
    methods: {
        identifyClientSubmitted: function (e) {
            e.preventDefault();
            
            if (this.$v.$invalid) return;

            if (!this.isAgreed)
                return alert(
                    "Sorry, You must accept terms and conditions to able to register!"
                );
            
            var scope = this;

            Api()
                .get(
                    `auth/get-required-data-registration?invitation_code=${this.invitation_code}`
                )
                .then((response) => {
                    let data = response.data;
                    
                    localStorage.clear();
                    localStorage.setItem("firstTimeRegister", "1");

                    this.$store
                        .dispatch("startRegistrationProccess", data)
                        .then(() => {
                            this.$router.push({ name: "register" });
                        });
                })
                .catch((error) => {
                    if (error) {
                        if (error.response.status == 422) {
                            var err = error.response.data;
                            scope.errorMsg = err.errors[0].message;
                        }
                    }
                });
        }
    }
};
</script>
